<style scoped>
    .not_found {
        font-size: 1.4em;
        font-weight: bold;
        text-align: center;
    }
</style>
<template>
    <form method="POST" @submit="validateForm" action="/admin/statistics/shift_statistics/excel">
        <input type="hidden" name="_token" value="" id="form_token">
        <div class="row">
            <div class="col-md-9">
                <div class="row">
                    <date-range-picker></date-range-picker>
                </div>
                <div class="form-group">
                    <label>Выберите обработчика*</label>
                    <select v-model="selected_user" class="form-control">
                        <option value="0">Все</option>
                        <option v-for="(value, key) in handle_users" :value="key">
                            {{ value }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-3" style="margin-top: 24px">
                <div class="form-group">
                    <div class="btn btn-primary form-control" @click="load" >
                        <i v-show="is_loading" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        <span v-show="!is_loading">
                            <i class="fa fa-file-excel-o"></i>
                            Выгрузить данные
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success form-control">
                        <i class="fa fa-file-excel-o"></i>
                        Сохранить в Excel
                    </button>
                </div>
            </div>
        </div>
        <div class="row" v-if="shifts.length">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th v-for="column in columns">{{ column.title }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(shift, key) in shifts">
                        <td v-for="column in columns">{{ shift[column.code] }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="not_found" v-else-if="!shifts.length && not_found == true">
            Данные не найдены. Проверьте правильность введенных фильтров
        </div>
    </form>
</template>
<script>
    export default {
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
            document.querySelector('#form_token').value = document.querySelector('#token').getAttribute('content');
        },
        props: {
            handle_users: Object
        },
        data: function () {

            let columns = [
                { code: 'email', title: 'Email' },
                { code: 'work_time', title: 'Рабочее время' },
                { code: 'relax_time', title: 'Время перерывов' },
                { code: 'start_time', title: 'Время начала' },
                { code: 'stop_time', title: 'Время окончания' },
            ];
            return {
                is_loading: false,
                date_start: '',
                date_finish: '',
                selected_user: '',
                shifts: '',
                columns: columns,
                not_found: false,
            };
        },
        methods: {
            load(e) {
                if(!this.validateForm(e)) {
                    return false;
                }

                this.is_loading = true;
                this.$http.post(
                    '/statistics/shift_statistics/get', {
                        'date_start': this.date_start,
                        'date_finish': this.date_finish,
                        'user': Number.parseInt(this.selected_user)
                    }
                ).then(response => {
                    this.is_loading = false;
                    this.shifts = response.data.data.shifts
                }).catch(response => {
                    this.is_loading = false;
                    this.shifts = '';
                    this.not_found = true;
                });
            },
            validateForm (e) {
                 if(this.date_start && this.date_finish && this.selected_user) {
                     return true;
                 }

                 alert('Заполните обязательные поля!');
                 e.preventDefault();
            },
        },
        created () {
            this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
        }

    };
</script>
